import { jsx as _jsx } from "react/jsx-runtime";
import { LinkPlugin as LexicalLinkPlugin } from '@lexical/react/LexicalLinkPlugin';
import React from 'react';
// This is the recommended regular expressions from the Lexical Playground Link Plugin
// https://github.com/facebook/lexical/blob/main/packages/lexical-playground/src/plugins/LinkPlugin/index.tsx
// https://github.com/facebook/lexical/blob/main/packages/lexical-playground/src/utils/url.ts
const urlRegExp = new RegExp(/((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=+$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=+$,\w]+@)[A-Za-z0-9.-]+)((?:\/[+~%/.\w-_]*)?\??(?:[-+=&;%@.\w_]*)#?(?:[\w]*))?)/);
const validateUrl = (url) => {
    return url === 'https://' || urlRegExp.test(url);
};
const attributes = { rel: 'noopener noreferrer', target: '_blank' };
export const LinkPlugin = React.memo(function LinkPlugin({ attributes: configuredAttributes = attributes, validateUrl: configuredValidateUrl = validateUrl, }) {
    return (_jsx(LexicalLinkPlugin, { validateUrl: configuredValidateUrl, attributes: configuredAttributes }));
});
export default LinkPlugin;
//# sourceMappingURL=LinkPlugin.js.map